import { PropType, Transition, defineComponent, onMounted, reactive, watch } from 'vue'
import { ChargeMapContext } from '../chargerMap/index.model'
import { useRoute, useRouter } from 'vue-router'
import { Store } from 'pinia'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'

export default defineComponent({
  name: 'new-station-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    const router = useRouter()
    const route = useRoute()
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    /**
     * 组件获取地图实例后的回调
     */
    const onReady = async () => {
      if (window.location.href.includes('/newStation')) {
        if (componentsConfig.new_station?.show) {
          const period = route.query.period
          window.backHistoryNum = 0
          await router.replace({
            name: 'home',
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          }) // 为了保证回退时回到首页
          window.backHistoryNum++
          router.push({
            name: 'newStation',
            query: { period },
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          })
          props.componentStore.$patch({
            showHandleBox: false,
          })
          props.componentStore.$patch({
            showSummary: false,
          })
        } else {
          window.backHistoryNum = 0
          await router.replace({
            name: 'home',
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          }) // 为了保证回退时回到首页
          props.componentStore.$patch({
            showHandleBox: false,
          })
          props.componentStore.$patch({
            showSummary: true,
          })
          props.componentStore.bus.emit('onChangeHeightLevel', 1) // dragPopup高度回到1
        }
      }
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          onReady()
        }
      },
      {
        immediate: true,
      }
    )
    return () => {}
  },
})
